
const digest = '9a57293f54760bc800cb375f343bca5b1f6e9869947ba8aba23cd5dc1f106aa8';
const css = `._lightboxjs_bsfex_1 {
    margin: 0;
    padding: 0;
  }
  
  ._lightboxjs_bsfex_1 * {
    box-sizing: border-box;
  }
  
  /* .lightboxjs img,
  .lightboxjs svg,
  .lightboxjs video {
    display: block;
    vertical-align: middle;
    height: auto;
    max-width: 100%;
  } */
  
  ._slideshowContainer_bsfex_37 {
    background-color: black;
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
  }
  
  ._slideshowBtn_bsfex_55 {
    padding-bottom: 2px;
  }
  
  ._closeIcon_bsfex_63:hover,
  ._closeIcon_bsfex_63:focus,
  ._iconsHeader_bsfex_67 svg:hover,
  ._iconsHeader_bsfex_67 svg:focus,
  ._prev1_bsfex_71 span:hover,
  ._next1_bsfex_73:hover,
  ._icon_bsfex_67:hover {
    text-decoration: none;
    cursor: pointer;
    /* color: rgb(230, 230, 230); */
  }
  
  /* On hover, add a black background color with a little bit see-through */
  ._prevIcon_bsfex_89:hover,
  ._nextIcon_bsfex_91:hover {
    background-color: rgba(0, 0, 0, 0.8);
    color: rgb(230, 230, 230);
  }
  
  ._show_bsfex_101 {
    display: flex;
  }
  
  ._displayHidden_bsfex_109 {
    display: none;
  }
  
  ._thumbnail_bsfex_117 {
    opacity: 1;
    transition: all 0.3s;
    cursor: pointer;
    position: relative;
  }
  
  img._hoverShadow_bsfex_131 {
    transition: 0.3s;
  }
  
  ._hoverShadow_bsfex_131:hover {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
  
  ._next1_bsfex_73 {
    right: 1%;
    padding-left: 2vw;
    padding-right: 3vw;
  }
  
  ._prev1_bsfex_71 {
    left: 2%;
    padding-right: 2vw;
  }
  
  
  ._thumbnails_bsfex_171 {
    transition: border 0.3s;
  }
  
  ._thumbnail_bsfex_117 {
    display: inline;
  }
  
  ._thumbnailsWithCaption_bsfex_187 {
    width: 90%;
  }
  
  ._navigationDots_bsfex_195 {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  
  /* Mobile screens */
  @media screen and (min-width: 20em) {
    ._imageSlide_bsfex_211 {
      height: 67vw;
      width: 60%;
    }

    ._thumbnailsOuterContainer_bsfex_221 {
      position: fixed;
      bottom: 5%;
      width: 100vw;
      /* width: 100%; */
    }
  
    ._hideControlsBar_bsfex_235 ._slideshowImg_bsfex_235 {
      height: 100vh;
    }
  
    ._rotateImgInnerContainer_bsfex_243 {
      top: 8%;
    }
  
    ._hideControlsBar_bsfex_235 ._slideshowInnerContainer_bsfex_251 {
      top: 0;
    }
  
    ._thumbnail_bsfex_117 {
      width: 80px;
      max-width: 80px;
      height: 7vh;
    }
  
    ._videoThumbnailsOuterContainer_bsfex_271 {
      bottom: 2%;
    }
  
    ._imgTitleContainer_bsfex_279 {
      padding-bottom: 16px;
      width: 100vw;
    }
  
    ._thumbnails_bsfex_171 {
      margin-left: auto;
      margin-right: auto;
    }
  
    ._next1_bsfex_73 {
      right: 0.9%;
    }
  
    ._prev1_bsfex_71 {
      left: 1.5%;
    }
  }
  
  ._thumbnail_bsfex_117 {
    height: 5vh;
    border-radius: 6px;
    margin-right: 7px;
    object-fit: cover;
  }
  
  ._thumbnailsOuterContainer_bsfex_221 {
    position: absolute;
    bottom: 10%;
    height: 5vh;
    width: 100vw;
    z-index: 10000000;
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }
  
  ._thumbnailsOuterContainerMetadata_bsfex_355 {
    width: 78vw;
  }
  
  ._videoThumbnailsOuterContainer_bsfex_271 {
    bottom: 5%;
  }
  
  ._thumbnailsAndCaption_bsfex_371 {
    height: 19vh;
  }
  
  ._htmlVideoOuterContainer_bsfex_379 video {
    height: 100%;
    max-height: 70vh;
    width: 100%;
  }
  
  ._caption_bsfex_391 {
    position: absolute;
    bottom: 14%;
    width: 100vw;
    z-index: 10000000;
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
  }
  
  ._galleryImg_bsfex_411 {
    cursor: pointer;
    margin: 0.2em;
  }
  
  ._modalContainer_bsfex_421 {
    width: 100vw;
    height: 100%;
    max-height: 100%;
    direction: ltr;
    overflow: hidden;
    touch-action: none;
    padding: 0;
    overflow-y: hidden;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000000;
  }
  
  ._slideshowAnimContainer_bsfex_459 {
    height: 100%;
    max-height: 100%;
    direction: ltr;
    overflow: hidden;
    touch-action: none;
    padding: 0;
    overflow-y: hidden;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    /* position: fixed; */
    top: 0;
    left: 0;
    z-index: 1000000;
  }
  
  ._fullScreenContainer_bsfex_495 img {
    height: 100vh;
    max-width: 100%;
    max-height: 100%;
  }
  
  ._imageInnerContainer_bsfex_507 img {
    height: 80vh;
    max-width: 100%;
    max-height: 100%;
  }
  
  ._imageInnerContainer_bsfex_507 {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    top: 0;
    align-content: center;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    z-index: 1000000;
  }
  
  ._magnifyWrapper_bsfex_545 {
    margin-bottom: 3em;
    margin-left: auto;
    margin-right: auto;
  }
  
  ._slideshowInnerContainer_bsfex_251 {
    /* position: fixed; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    transition: top 0.2s ease-in-out 0s;
    top: 10%;
    align-content: center;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    z-index: 1000000;
  }
  
  ._slideshowInnerVideoContainer_bsfex_585 {
    top: 6%;
  }
  
  ._slideshowInnerContainerThumbnails_bsfex_593 {
    top: 12%;
  }
  
  ._hideControlsBar_bsfex_235  {
    top: 0;
  }
  
  ._fullScreenContainer_bsfex_495 {
    top: 0;
  }
  
  ._lightboxContainer_bsfex_617 {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  ._next1_bsfex_73,
  ._prev1_bsfex_71 {
    top: calc(50% - 20px);
    position: absolute;
    display: flex;
    transition: all 0.2s;
    justify-content: center;
    align-items: center;
    padding-bottom: 2vh;
    padding-top: 2vh;
    user-select: none;
    cursor: pointer;
    font-weight: bold;
    border-radius: 30px;
    width: 40px;
    height: 40px;
    font-size: 18px;
    z-index: 10000000;
  }
  
  
  
  ._next1_bsfex_73:hover,
  ._prev1_bsfex_71:hover {
    color: rgb(230, 230, 230);
  }
  
  ._slideshowAnimImg_bsfex_689 {
    position: absolute;
    max-width: 100vw;
  }
  
  ._controls_bsfex_699 {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  
  ._iconsHeader_bsfex_67 {
    color: white;
    position: absolute;
    display: flex;
    flex-direction: row;
    /* align-items: center;
      justify-content: center; */
    cursor: pointer;
    top: 10px;
    right: 45px;
    z-index: 999999999;
    /* padding: 0.14vw; */
  }
  
  ._ytVideo_bsfex_739 {
    aspect-ratio: 16 / 9;
    height: 65vh;
    width: 100%;
  }
  
  ._videoOuterContainer_bsfex_751 {
    width: 65%;
    margin-left: auto;
    margin-right: auto;
    height: 60vh;
    max-height: 65vh;
  }
  
  ._htmlVideoOuterContainer_bsfex_379 {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }
  
  ._customVideoContainer_bsfex_779, ._customEmbedContainer_bsfex_779 {
    margin-left: auto;
    margin-right: auto;
  }
  
  ._videoIconsHeader_bsfex_789 {
    position: fixed;
    top: 4%;
    right: 3%;
  }
  
  ._lightbox_bsfex_1 ._iconsHeader_bsfex_67 svg {
    transition: 0.3s all;
  }
  
  ._iconsHeader_bsfex_67 svg:active {
    transform: scale(0.97);
  }
  
  ._imgTitle_bsfex_279 {
    text-align: center;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }
  
  ._iconsHeader_bsfex_67 svg {
    margin-left: 0.6em;
    padding: 0.2em;
    transition: all 0.1s;
    /* width: 32px;  */
    /* font-size: 18px; */
    line-height: 16px;
    vertical-align: baseline;
  }
  
  ._icon_bsfex_67 {
    /* width: 32px;  */
  }
  
  @media screen and (min-width: 6em) {
    ._iconsHeader_bsfex_67 {
      top: 3%;
    }
  
    ._slideshowAnimContainer_bsfex_459 {
      width: 100vw;
    }
  
    ._iconsHeader_bsfex_67 svg {
      /* width: 34px;  */
      padding-right: 0.3em;
    }
  
    ._lightboxjs_bsfex_1 img {
      cursor: pointer;
    }
  
    ._thumbnail_bsfex_117 {
      height: 9vh;
      /* width: 22vw; */
    }
  
    ._next1_bsfex_73 {
      top: calc(48% - 20px);
    }
  
    ._prev1_bsfex_71 {
      top: calc(48% - 20px);
  
    }
  
  
  }
  
  @media screen and (min-width: 39em) {
    ._slideshowAnimContainer_bsfex_459 {
      width: 100vw;
    }
  
    ._slideshowInnerContainer_bsfex_251 {
      width: 100vw;
      height: 95vh;
      position: absolute;
    }
  
    ._imgTitleContainer_bsfex_279 {
      padding-bottom: 0px;
    }
    
  
    ._next1_bsfex_73 {
      right: 0.7%;
    }
  
    /* .hideControlsBar .slideshow_img {
      height: 70vh;
  
    }
  
    .hideControlsBar {
      top: 10%;
    } */
  
    ._fullScreenContainer_bsfex_495 {
      width: 100vw;
      height: 100vh;
    }
  
    ._fullScreenContainer_bsfex_495 img {
      height: 100vh;
    }
  
    ._thumbnails_bsfex_171 {
      margin-top: 0.6em;
    }
  
    ._thumbnail_bsfex_117 {
      /* height: 8vh; */
      width: 80px;
      max-width: 80px;
    }
  
    ._iconsHeader_bsfex_67 svg {
      /* width: 32px; 
        font-size: 32px; */
    }
  
    ._prev1_bsfex_71 {
      left: 2.7%;
      padding-right: 2vw;
    }
  }
  
  /* Desktop screens */
  @media screen and (min-width: 42em) {
    ._imageSlide_bsfex_211 {
      height: 70vh;
      width: 80vw;
    }

    ._innerContainerWithTopCaption_bsfex_1061 {
      top: 8%;
    }

    ._slideshowImgFullscreen_bsfex_1069 {
      display: grid;
      width: 92vw;
      place-items: start;
      margin-left: auto;
      margin-right: auto;
      scrollbar-gutter: stable both-edges;
    }
    
    ._rotateImgInnerContainer_bsfex_243 {
      top: 2%;
    }
  
    ._slideshowInnerContainer_bsfex_251 img {
      margin-top: 0vh;
      /* width: 70vw; */
    }
  
    ._fullScreenContainer_bsfex_495 img {
      width: 80vw;
    }
  
    ._slideshowInnerContainerFullScreen_bsfex_1113 {
      top: 0%;
    }
  
    ._fullScreenLightboxImg_bsfex_1121 {
      margin-left: auto;
      margin-right: auto;
      height: 100vh;
    }

    ._slideshowInnerContainerImgMetadata_bsfex_1133 {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: flex-start;
    }
  
    ._slideshowInnerContainerFullScreen_bsfex_1113 {
      height: 100vh;
      width: 100vw;
      position: absolute;
    }
  
    ._slideshowInnerContainerFullScreen_bsfex_1113 img {
      object-fit: contain;
    }
  
    ._thumbnails_bsfex_171 {
      scrollbar-width: none;
      -ms-overflow-style: none;
      margin-top: 1.1em;
    }
  
    ._thumbnails_bsfex_171::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
  
    ._opacity-fade_bsfex_1187 {
      transition: opacity 0.3s;
      -webkit-transition: opacity 0.3s;
      opacity: 1;
    }
  
    ._thumbnailsOuterContainer_bsfex_221 {
      margin-top: 0.1em;
      padding-top: 0.3em;
      height: 5vh;
      bottom: 11%;
    }
  
    ._thumbnail_bsfex_117,
    ._imageSliderThumbnails_bsfex_1215 img {
      height: 10vh;
      /* width: 7em; */
    }
  
    ._slideshowAnimContainer_bsfex_459 {
      width: 100vw;
    }
  
    ._slideshowInnerContainer_bsfex_251 {
      width: 100vw;
      height: 95vh;
    }
  
    ._hideControlsBar_bsfex_235 {
      height: 100vh;
    }
  
    ._fullScreenContainer_bsfex_495 {
      width: 100vw;
      height: 100vh;
    }
  
    ._iconsHeader_bsfex_67 svg {
      /* width: 37px;
        font-size: 34px; */
    }
  
    ._prev1_bsfex_71 {
      left: 2%;
      padding-right: 2vw;
    }
  
    ._next1_bsfex_73 {
      right: 0.4%;
    }
  
    
    ._slideshowImgMetadata_bsfex_1291 {
      width: 78vw;
    }
  
    ._prev1Metadata_bsfex_1299 {
      left: 1%;
    }
  
    ._navigationDots_bsfex_195 {
      gap: 8px;
    }
  }
  
  @media screen and (min-width: 53em) {
    
    ._slideshowImg_bsfex_235 {
      display: grid;
      width: 100vw;
      height: 70vh;
      place-items: start;
      /* margin-top: 7vh; */
    }
  
    ._hideControlsBar_bsfex_235 ._slideshowImg_bsfex_235, ._hideControlsBarAndCaption_bsfex_1337 ._slideshowImg_bsfex_235  {
      padding-top: 12vh;
    }

    ._fullScreenContainer_bsfex_495 ._slideshowImg_bsfex_235 {
      padding-top: 0vh;
    }
  
  
    ._lightboxImg_bsfex_1355 {
        /* height: 70vh; */
    }
  
    ._thumbnail_bsfex_117 {
      width: 95px;
      max-width: 80px;
    } 
  
    ._slideshowImgMetadata_bsfex_1291 {
      width: 78vw;
    }
  }
    
  
  @media screen and (min-width: 80em) {
    ._slideshowInnerContainer_bsfex_251 img {
      /* width: 60vw; */
    }
  
    ._fullScreenContainer_bsfex_495 img {
      width: 80vw;
    }
  }
  
  ._lightIcon_bsfex_1405,
  ._lightIcon_bsfex_1405 svg {
    background-color: white;
    color: black;
  }
  
  ._lightIcon_bsfex_1405:hover,
  ._lightIcon_bsfex_1405 svg:hover {
    background-color: white;
    color: black;
    fill: black;
  }
  
  ._darkIcon_bsfex_1431,
  ._darkIcon_bsfex_1431 svg {
    background-color: transparent;
    /* background-color: #151515; */
    color: silver;
    fill: silver;
  }
  
  ._darkIcon_bsfex_1431:hover,
  ._darkIcon_bsfex_1431 svg:hover {
    color: rgba(107, 107, 107, 0.8);
    fill: rgba(107, 107, 107, 0.8);
  }
  
  /* Header icons  */
  ._lightHeaderIcon_bsfex_1461 svg {
    background-color: white;
    color: black;
    fill: black;
  }
  
  ._lightHeaderIcon_bsfex_1461 svg:hover {
    background-color: white;
    color: rgb(24, 24, 24, 0.8);
    fill: rgb(24, 24, 24, 0.8);

  }
  
  ._darkHeaderIcon_bsfex_1487 svg {
    background-color: transparent;
    /* background-color: #151515; */
    color: #626b77;
    fill: #626b77;
  }
  
  ._darkHeaderIcon_bsfex_1487 svg:hover {
    color: rgba(99, 99, 99, 0.8);
    fill: rgba(99, 99, 99, 0.8);
  }
  
  ._magnifierImage_bsfex_1511 {
    object-fit: contain;
  }
  
  ._thumbnails_bsfex_171 ._active_bsfex_1519 {
    border: solid rgb(107, 133, 206) 2px;
  }
  
  ._inactiveThumbnailBorder_bsfex_1527 {
    border: solid transparent 2px;
  }
  
  ._thumbnails_bsfex_171 {
    width: 95%;
  }
  
  ._emblaThumbs_bsfex_1543 {
    --thumbs-slide-spacing: 2px; 
    /* --thumbs-slide-height: 9rem; */
    margin-top: var(--thumbs-slide-spacing);
  }

  @media screen and (max-width: 40em) {
    ._innerContainerWithTopCaption_bsfex_1061 {
      position: relative;
    }
  
    ._imgTitleContainer_bsfex_279 {
      position: absolute;
      top: 12%;
    }
  }

  @media screen and (max-width: 44em) and (min-width: 30em) {
    ._innerContainerWithTopCaption_bsfex_1061 {
      position: relative;
    }
  
    ._imgTitleContainer_bsfex_279 {
      position: absolute;
      top: 5%;
    }
  }

  @media screen and (max-width: 46em) and (min-width: 30em) {
    ._innerContainerWithTopCaption_bsfex_1061 {
      position: relative;
    }
  
    ._imgTitleContainer_bsfex_279 {
      position: absolute;
      top: 7%;
    }
  }
  
  @media screen and (max-width: 49em) and (min-width: 45em) {
    ._innerContainerWithTopCaption_bsfex_1061 {
      position: relative;
    }
  
    ._imgTitleContainer_bsfex_279 {
      position: absolute;
      top: 5%;
    }
  }
  
  @media screen and (max-width: 29em) {
    ._fullScreenContainer_bsfex_495 img {
      object-fit: cover;
    }
  
    ._emblaThumbs_bsfex_1543 {
      --thumbs-slide-spacing: 3px; 
      /* --thumbs-slide-height: 9rem; */
      margin-top: var(--thumbs-slide-spacing);
    }



    ._htmlVideo_bsfex_379 {
      margin-top: 5vh;
    }
  
    ._thumbnails_bsfex_171 {
      width: 98%;
    }
  
    ._thumbnail_bsfex_117 {
      width: 80px;
      max-width: 80px;
    }
  
    ._htmlVideoOuterContainer_bsfex_379 video {
      max-height: 65vh;
    }
  
    ._videoIconsHeader_bsfex_789 {
      position: fixed;
      top: 2%;
      right: 15px;
    }
  
    ._videoOuterContainer_bsfex_751 {
      width: 88%;
      margin-left: auto;
      margin-right: auto;
      height: 100%;
      max-height: 65vh;
    }
  
    ._htmlVideoOuterContainer_bsfex_379 {
      width: 94%;
      margin-left: auto;
      margin-right: auto;
    }
  
    ._iconsHeader_bsfex_67 {
      position: fixed;
      left: 115px;
    }
  
    ._slideshowInnerVideoContainer_bsfex_585 {
      top: 3%;
    }
  
    ._next1_bsfex_73,
    ._prev1_bsfex_71 {
      padding-bottom: 2vh;
      padding-top: 2vh;
    }
  
    ._next1_bsfex_73 {
      padding-left: 4vw;
    }
  
    ._prev1_bsfex_71 {
      padding-right: 4vw;
    }
  
    ._iconsHeader_bsfex_67 {
      /* font-size: 28px; */
    }
  
  }



  
  @media screen and (max-width: 53em) {
    ._slideshowImg_bsfex_235 {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      width: 100vw;
      height: 70vh;
    }
  
    ._slideshowImg_bsfex_235 img {
      margin-left: auto;
      margin-right: auto;
    }
  
    ._slideshowImg_bsfex_235 {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      width: 100vw;
      height: 70vh;
    }
  
    ._slideshowInnerContainerFullScreen_bsfex_1113 {
      position: fixed;
      display: flex;
      flex-direction: column;
      justify-content: center;
      transition: top 0.2s ease-in-out 0s;
      top: 10%;
      align-content: center;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
      z-index: 1000000;
    }
  
    ._containImg_bsfex_1883 {
      object-fit: contain;
    }
  
  }
  
  ._fullScreenContainer_bsfex_495 img {
    object-fit: contain;
    width: 100%;
    height: 100%;
    
  }
  
  ._thumbnails_bsfex_171 {
    text-align: center;
    white-space: nowrap;
  }
  
  ._reactTransformComponent_bsfex_1919 {
    margin-left: auto;
    margin-right: auto;
  }
  
  ._magnifierImage_bsfex_1511 {
    margin-left: auto;
    margin-right: auto;
  }
  
  /* CSS loader  */
  ._loader_bsfex_1941 {
    width: 44px;
    height: 44px;
    box-sizing: border-box;
  
    border-radius: 50%;
  
    display: inline-block;
    position: fixed;
    top: 50%;
    left: 50%;
    animation: _rotation_bsfex_1 1s linear infinite;
  }
  
  @keyframes _rotation_bsfex_1 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
  ._dayLoader_bsfex_1987 {
    border: 5px solid #626b77;
    border-bottom-color: transparent;
  }
  
  ._nightLoader_bsfex_1997 {
    border: 5px solid #fff;
    border-bottom-color: transparent;
  }
  
  ._lightboxImg_bsfex_1355 {
    max-height: 70vh;
    margin-left: auto;
    margin-right: auto;
  }
  
  ._controls_bsfex_699 button, ._closeButton_bsfex_2019, ._closeButtonRounded_bsfex_2019 {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-size: 16px;
  }
  
  ._controls_bsfex_699 svg {
    box-sizing: border-box;
  }
  
  ._closeButton_bsfex_2019 svg, ._closeButtonRounded_bsfex_2019 svg {
    box-sizing: border-box;
    font-size: 16px;
    padding-top: 0.5px;
  }
  
  ._closeButton_bsfex_2019 {
    padding-top: 3px;
  }
  
  ._closeButtonRounded_bsfex_2019 {
    cursor: pointer;
  
  }
  
  ._closeButtonRounded_bsfex_2019 svg {
    margin: 0;
    padding: 5px;
    background-color: black;
    border-color: transparent;
    border-radius: 28px;
  
  }
  
  ._thumbnailsAndCaption_bsfex_371 {
    bottom: 0%;
    height: 19vh;
    margin-top: 0em;
    width: 100vw;
  }
  
  ._thumbnailsWithCaption_bsfex_187 {
    margin-top: 0em;
  }
  
  ._slideImageAndCaption_bsfex_2113 {
    top: 9%;
  }
  
  ._slideImageAndCaption_bsfex_2113._hideControlsBar_bsfex_235 {
    top: 0;
  }
  
  ._slideshowAnimContainer_bsfex_459 {
    -ms-overflow-style: none;
    /* scrollbar-width: none;   */
  }
  ._thumbnails_bsfex_171::-webkit-scrollbar {
    display: none;
  }
  
  ._roundedBorder_bsfex_2145 {
    border-radius: 20px;
  }
  
  ._maxWidthFull_bsfex_2153 {
    max-width: 100%;
  }
  
  ._maxWidthWithoutMagnifier_bsfex_2161 {
    max-width: 80%;
  }
  
  @media screen and (max-width: 880px) {
    ._iconsHeader_bsfex_67 {
      position: fixed;
      right: 5%;
    }
  }
  
  @media screen and (max-width: 480px) {
    ._iconsHeader_bsfex_67 {
      position: fixed;
      left: 180px;
    }
    
  }
  
  @media screen and (max-width: 440px) {
    ._iconsHeader_bsfex_67 {
      position: fixed;
      left: 160px;
    }
  }
  
  @media screen and (max-width: 410px) {
    ._iconsHeader_bsfex_67 {
      position: fixed;
      left: 140px;
    }
  }
  
  @media screen and (max-width: 385px) {
    ._iconsHeader_bsfex_67 {
      position: fixed;
      left: 135px;
      /* top: 24px; */
    }
  }
  
  @media screen and (max-width: 365px) {
    ._iconsHeader_bsfex_67 {
      position: fixed;
      left: 90px;
    }
  }
  
  @media screen and (max-width: 345px) {
    ._iconsHeader_bsfex_67 {
      position: fixed;
      left: 82px;
    }
  }
  
  @media screen and (max-width: 325px) {
    ._iconsHeader_bsfex_67 {
      position: fixed;
      left: 60px;
    }
  }
  
  @media screen and (max-width: 300px) {
    ._iconsHeader_bsfex_67 {
      position: fixed;
      left: 30px;
    }
  }
  
  ._lightboxVideo_bsfex_2299 {
    margin-left: auto;
    margin-right: auto;
  }
 
  ._navigation-wrapper_bsfex_2309 {
    position: relative;
  }
  
  ._dots_bsfex_2317 {
    display: flex;
    padding: 10px 0;
    justify-content: center;
  }
  
  ._dot_bsfex_2317 {
    border: none;
    width: 10px;
    height: 10px;
    background: #c5c5c5;
    border-radius: 50%;
    margin: 0 5px;
    padding: 5px;
    cursor: pointer;
  }
  
  ._dot_bsfex_2317:focus {
    outline: none;
  }
  
  ._dot_bsfex_2317._active_bsfex_1519 {
    background: #000;
  }
  
  ._arrow_bsfex_2367 {
    position: absolute;
    top: 50%;
    font-size: 24px;
    font-weight: bold;
    transition: all 0.2s;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    color: #fff;
    cursor: pointer;
    padding-top: 10px;
    padding-bottom: 10px;
    font-family: sans-serif;
  }
  
  ._leftArrow_bsfex_2397 {
    left: 8px;
    padding-right: 10px;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  
  ._rightArrow_bsfex_2411 {
    left: auto;
    right: 8px;
    padding-left: 10px;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  
  ._arrow_bsfex_2367:hover {
    color: rgb(230, 230, 230);
  }
  
  ._arrow--disabled_bsfex_2435,
  ._arrow--disabled_bsfex_2435:hover {
    color: rgba(255, 255, 255, 0.5);
  }
  
  ._navDotsMargin_bsfex_2445 {
    margin-top: 12px;
  }
  
  ._inactiveThumbnailBorderImgSlider_bsfex_2453 {
    border: 'solid transparent 2px';
  }
  
  ._ytVideoImgSlider_bsfex_2461 {
    width: 100%;
    height: 100%;
  }
  
  ._ytVideoImgSlider_bsfex_2461 iframe {
    width: 100%;
    height: 100%;
  }
  
  ._outerYTVideoImgSlider_bsfex_2481 {
    height: 100%;
  }
  
  ._lightboxjs_bsfex_1 iframe {
    margin: none;
    padding: none;
    border: none;
  }
  
  ._imgSliderArrow_bsfex_2501 {
    z-index: 100000;
    background-color: transparent;
    border: none;
  }
  
  ._thumbnails_bsfex_171 {
    margin-left: auto;
    margin-right: auto;
  }
  
  ._cursorPointer_bsfex_2523 {
    cursor: pointer;
  }
  
  ._lightboxjsIcon_bsfex_2531 > * { color: inherit; fill: inherit }
  
  ._embla_bsfex_1543 {
    margin-left: auto;
    margin-right: auto;
    --slide-spacing: 1rem;
    --slide-size: 100%;
    --slide-height: 19rem;
  }
  
  ._emblaViewport_bsfex_2551 {
    overflow: hidden;
    width: 100vw;
  }
  
  ._emblaContainer_bsfex_2561 {
    backface-visibility: hidden; 
    touch-action: pan-y;
    height: auto;
    margin-left: calc(var(--slide-spacing) * -1);
    display: grid;  
    grid-auto-flow: column;  
    grid-auto-columns: 100%; 
    max-width: 100vw;
    margin-left: auto;
    margin-right: auto; 
    /* width: 80%;
  */
  }
  
  ._emblaContainerImgMetadata_bsfex_2591 {
    width: 78vw;
    max-width: 78vw;
    height: 80vh;
  }
  
  ._imgdrag_bsfex_2603 ._emblaSlide_bsfex_2603 {
    flex: 0 0 80%;
    min-width: 0;
    max-width: 100%;
    padding-left: 12px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
  }
  
  ._emblaThumbsViewport_bsfex_2623 {
    overflow: hidden;
  }
  
  ._emblaThumbsContainer_bsfex_2631 {
    display: flex;
    flex-direction: row;
    margin-left: calc(var(--thumbs-slide-spacing) * -1);
    width: 100%;
    /* align-items: center;
    text-align: center;
    width: fit-content; */
    /* justify-content: center; */
    
  }
  
  ._emblaThumbsContainer_bsfex_2631::before, ._emblaThumbsContainer_bsfex_2631::after {
    content: '';  /* Insert pseudo-element */
    margin: auto; /* Make it push flex items to the center */
  }
  
  
  ._emblaThumbsSlide_bsfex_2667 {
    /* min-width: 0; */
    padding-left: var(--thumbs-slide-spacing);
    /* position: relative; */
    /* width: 140px; */
  }
  
  ._emblaThumbsSlideImg_bsfex_2681 {
    /* display: block; */
    height: var(--thumbs-slide-height);
    width: 100%;
    object-fit: cover;
  }
  
  ._mlAuto_bsfex_2695 {
    margin-left: auto;
  }
  
  ._metadata_bsfex_2703 {
    color: white;
  }
  
  ._emblaSlideGrid_bsfex_2711 {
    display: flex;
  }
  
  ._metadata_bsfex_2703 {
    text-align: left;
    min-width: 17vw;
    max-width: 17vw;
    padding-top: 5vw;
  }
  
  ._metadataPanel_bsfex_2733 {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  
  ._metadataInnerContainer_bsfex_2745 {
    padding-left: 7vw;
  }
  
  ._metadataInnerContainer_bsfex_2745 span {
    display: block;
  }
  
  
  ._imgMetadataCloseBtn_bsfex_2763 {
    position: absolute;
    top: 1%;
    right: 2%;
    background: none;
    color: white;
    border: none;
    cursor: pointer;
  }
  
  /* Styling from react-zoom-pan-pinch library */
  ._reactTransformWrapper_bsfex_2785 {
    position: relative;
    width: -moz-fit-content;
    width: fit-content;
    height: -moz-fit-content;
    height: fit-content;
    overflow: hidden;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -khtml-user-select: none; /* Konqueror HTML */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    margin: 0;
    padding: 0;
  }
  
  ._reactTransformComponent_bsfex_1919 {
    display: flex;
    flex-wrap: wrap;
    width: -moz-fit-content;
    width: fit-content;
    height: -moz-fit-content;
    height: fit-content;
    margin: 0;
    padding: 0;
    transform-origin: 0% 0%;
  }
  
  ._reactTransformComponent_bsfex_1919 img {
    pointer-events: none;
  }
  
  ._navigationDot_bsfex_195 {
    height: 10px;
    width: 10px;
    background-color: silver;
    border-radius: 8px;
    border: none;
    cursor: pointer;
  }
  
  ._navigationDotContainer_bsfex_2869 {
    padding-top: 24px;
    padding-bottom: 24px;
    padding-left: 12px;
    padding-right: 12px;
  }
  
  ._imgfade_bsfex_2883._emblaContainer_bsfex_2561 {
    transform: none !important; /* override Embla */
    display: flex;
    height: 250px;
  }
  
  ._imgfade_bsfex_2883._emblaSlide_bsfex_2603 {
    flex: 0 0 auto;
    width: 100%;
    height: 100%;
    position: absolute;
    /* top: 0; */
    left: 0 !important; /* override Embla */
    right: 0 !important; /* override Embla */
    opacity: 0;
    transition: opacity 0.5s;
    counter-increment: embla;
    border-radius: 0.5rem;
  }
  
  ._imgfade_bsfex_2883._emblaSlideSelected_bsfex_2923 {
    opacity: 1;
    transition: opacity 0.3s;
    z-index: 1;
  }
  
  ._imgfade_bsfex_2883._emblaSlide_bsfex_2603:before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ._fullImg_bsfex_2949 {
    height: 84vh;
    max-height: 84vh;
    object-fit: contain;
  }

._rotateImg90Deg_bsfex_2961{
  transform: rotate(90deg);
  transition: transform 1s linear;
}  

._rotate_img_bsfex_2971 {
  transition: transform 0.7s linear;
}

`;

(function() {
  if (typeof document === 'undefined') {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"lightboxjs":"_lightboxjs_bsfex_1","slideshowContainer":"_slideshowContainer_bsfex_37","slideshowBtn":"_slideshowBtn_bsfex_55","closeIcon":"_closeIcon_bsfex_63","iconsHeader":"_iconsHeader_bsfex_67","prev1":"_prev1_bsfex_71","next1":"_next1_bsfex_73","icon":"_icon_bsfex_67","prevIcon":"_prevIcon_bsfex_89","nextIcon":"_nextIcon_bsfex_91","show":"_show_bsfex_101","displayHidden":"_displayHidden_bsfex_109","thumbnail":"_thumbnail_bsfex_117","hoverShadow":"_hoverShadow_bsfex_131","thumbnails":"_thumbnails_bsfex_171","thumbnailsWithCaption":"_thumbnailsWithCaption_bsfex_187","navigationDots":"_navigationDots_bsfex_195","imageSlide":"_imageSlide_bsfex_211","thumbnailsOuterContainer":"_thumbnailsOuterContainer_bsfex_221","hideControlsBar":"_hideControlsBar_bsfex_235","slideshowImg":"_slideshowImg_bsfex_235","rotateImgInnerContainer":"_rotateImgInnerContainer_bsfex_243","slideshowInnerContainer":"_slideshowInnerContainer_bsfex_251","videoThumbnailsOuterContainer":"_videoThumbnailsOuterContainer_bsfex_271","imgTitleContainer":"_imgTitleContainer_bsfex_279","thumbnailsOuterContainerMetadata":"_thumbnailsOuterContainerMetadata_bsfex_355","thumbnailsAndCaption":"_thumbnailsAndCaption_bsfex_371","htmlVideoOuterContainer":"_htmlVideoOuterContainer_bsfex_379","caption":"_caption_bsfex_391","galleryImg":"_galleryImg_bsfex_411","modalContainer":"_modalContainer_bsfex_421","slideshowAnimContainer":"_slideshowAnimContainer_bsfex_459","fullScreenContainer":"_fullScreenContainer_bsfex_495","imageInnerContainer":"_imageInnerContainer_bsfex_507","magnifyWrapper":"_magnifyWrapper_bsfex_545","slideshowInnerVideoContainer":"_slideshowInnerVideoContainer_bsfex_585","slideshowInnerContainerThumbnails":"_slideshowInnerContainerThumbnails_bsfex_593","lightboxContainer":"_lightboxContainer_bsfex_617","slideshowAnimImg":"_slideshowAnimImg_bsfex_689","controls":"_controls_bsfex_699","ytVideo":"_ytVideo_bsfex_739","videoOuterContainer":"_videoOuterContainer_bsfex_751","customVideoContainer":"_customVideoContainer_bsfex_779","customEmbedContainer":"_customEmbedContainer_bsfex_779","videoIconsHeader":"_videoIconsHeader_bsfex_789","lightbox":"_lightbox_bsfex_1","imgTitle":"_imgTitle_bsfex_279","innerContainerWithTopCaption":"_innerContainerWithTopCaption_bsfex_1061","slideshowImgFullscreen":"_slideshowImgFullscreen_bsfex_1069","slideshowInnerContainerFullScreen":"_slideshowInnerContainerFullScreen_bsfex_1113","fullScreenLightboxImg":"_fullScreenLightboxImg_bsfex_1121","slideshowInnerContainerImgMetadata":"_slideshowInnerContainerImgMetadata_bsfex_1133","opacityFade":"_opacity-fade_bsfex_1187","imageSliderThumbnails":"_imageSliderThumbnails_bsfex_1215","slideshowImgMetadata":"_slideshowImgMetadata_bsfex_1291","prev1Metadata":"_prev1Metadata_bsfex_1299","hideControlsBarAndCaption":"_hideControlsBarAndCaption_bsfex_1337","lightboxImg":"_lightboxImg_bsfex_1355","lightIcon":"_lightIcon_bsfex_1405","darkIcon":"_darkIcon_bsfex_1431","lightHeaderIcon":"_lightHeaderIcon_bsfex_1461","darkHeaderIcon":"_darkHeaderIcon_bsfex_1487","magnifierImage":"_magnifierImage_bsfex_1511","active":"_active_bsfex_1519","inactiveThumbnailBorder":"_inactiveThumbnailBorder_bsfex_1527","emblaThumbs":"_emblaThumbs_bsfex_1543","htmlVideo":"_htmlVideo_bsfex_379","containImg":"_containImg_bsfex_1883","reactTransformComponent":"_reactTransformComponent_bsfex_1919","loader":"_loader_bsfex_1941","rotation":"_rotation_bsfex_1","dayLoader":"_dayLoader_bsfex_1987","nightLoader":"_nightLoader_bsfex_1997","closeButton":"_closeButton_bsfex_2019","closeButtonRounded":"_closeButtonRounded_bsfex_2019","slideImageAndCaption":"_slideImageAndCaption_bsfex_2113","roundedBorder":"_roundedBorder_bsfex_2145","maxWidthFull":"_maxWidthFull_bsfex_2153","maxWidthWithoutMagnifier":"_maxWidthWithoutMagnifier_bsfex_2161","lightboxVideo":"_lightboxVideo_bsfex_2299","navigationWrapper":"_navigation-wrapper_bsfex_2309","dots":"_dots_bsfex_2317","dot":"_dot_bsfex_2317","arrow":"_arrow_bsfex_2367","leftArrow":"_leftArrow_bsfex_2397","rightArrow":"_rightArrow_bsfex_2411","arrowDisabled":"_arrow--disabled_bsfex_2435","navDotsMargin":"_navDotsMargin_bsfex_2445","inactiveThumbnailBorderImgSlider":"_inactiveThumbnailBorderImgSlider_bsfex_2453","ytVideoImgSlider":"_ytVideoImgSlider_bsfex_2461","outerYtVideoImgSlider":"_outerYTVideoImgSlider_bsfex_2481","imgSliderArrow":"_imgSliderArrow_bsfex_2501","cursorPointer":"_cursorPointer_bsfex_2523","lightboxjsIcon":"_lightboxjsIcon_bsfex_2531","embla":"_embla_bsfex_1543","emblaViewport":"_emblaViewport_bsfex_2551","emblaContainer":"_emblaContainer_bsfex_2561","emblaContainerImgMetadata":"_emblaContainerImgMetadata_bsfex_2591","imgdrag":"_imgdrag_bsfex_2603","emblaSlide":"_emblaSlide_bsfex_2603","emblaThumbsViewport":"_emblaThumbsViewport_bsfex_2623","emblaThumbsContainer":"_emblaThumbsContainer_bsfex_2631","emblaThumbsSlide":"_emblaThumbsSlide_bsfex_2667","emblaThumbsSlideImg":"_emblaThumbsSlideImg_bsfex_2681","mlAuto":"_mlAuto_bsfex_2695","metadata":"_metadata_bsfex_2703","emblaSlideGrid":"_emblaSlideGrid_bsfex_2711","metadataPanel":"_metadataPanel_bsfex_2733","metadataInnerContainer":"_metadataInnerContainer_bsfex_2745","imgMetadataCloseBtn":"_imgMetadataCloseBtn_bsfex_2763","reactTransformWrapper":"_reactTransformWrapper_bsfex_2785","navigationDot":"_navigationDot_bsfex_195","navigationDotContainer":"_navigationDotContainer_bsfex_2869","imgfade":"_imgfade_bsfex_2883","emblaSlideSelected":"_emblaSlideSelected_bsfex_2923","fullImg":"_fullImg_bsfex_2949","rotateImg90Deg":"_rotateImg90Deg_bsfex_2961","rotateImg":"_rotate_img_bsfex_2971"};
export { css, digest };
  